import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { CritereViewModel } from '../../../models/publipostage-modele/listesParametragesModeleMailViewModel';
import { ValidatorsBuilderService } from '../../../validators/validators-with-message/eparcours-validators/validators-builder.service';

@Component({
  selector: 'app-criteres-selector-multi',
  templateUrl: './criteres-selector-multi.component.html',
  styleUrls: ['./criteres-selector-multi.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CriteresSelectorMultiComponent),
      multi: true,
    },
  ],
})

export class CriteresSelectorMultiComponent implements OnInit {
  selected: number[];
  formControl: UntypedFormControl = new UntypedFormControl(null, this.validatorsBuilder.required());
  allCriteres: CritereViewModel[];
  criteresVisibles: CritereViewModel[];

  @Input() set criteres(value: CritereViewModel[]) {
    if (value != this.allCriteres) {
      this.allCriteres = value;
    }
  }
  @Input() isError;

  constructor(private validatorsBuilder: ValidatorsBuilderService) {
    this.formControl.valueChanges.subscribe(newValue => {

      const hasChanged = !this.sameLists(newValue, this.selected);
      this.selected = newValue;
      if (hasChanged && this.onChange != null && this.formControl.dirty) {
        this.onChange(newValue);
      }
    });
  }

  onChange: (value) => any = v => {
  };

  ngOnInit(): void {
  }

  registerOnChange(fn: (value) => any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => any): void {
  }

  sameLists(list1: number[], list2: number[]) {
    return list1 != null && list2 != null && list1.length == list2.length && list1.every(id => list2.indexOf(id) >= 0);
  }

  writeValue(ids: number[]): void {
    if (!this.sameLists(ids, this.selected)) {
      this.selected = ids;
      this.onChange(ids);
      this.formControl.reset(ids);
    }
  }
}
